import script from "./BTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BTable.vue?vue&type=script&setup=true&lang=ts"

import "./BTable.vue?vue&type=style&index=0&id=80927b4e&lang=scss"

const __exports__ = script;

export default __exports__